<div>
    <br>
    <mat-checkbox labelPosition="before" disabled="true" [checked]="model.status === 1">
      {{'DETAIL_AUDIT.ACTIVE' | translate}} 
    </mat-checkbox>
    <mat-form-field class="one-sixth-size">
        <input matInput placeholder="{{'DETAIL_AUDIT.VERSION' | translate}}" [value]="model.version" readonly>
    </mat-form-field>
    <mat-form-field class="one-fifth-size">
        <input matInput placeholder="{{'DETAIL_AUDIT.CHANGED_BY' | translate}}" [value]="model.changedByName" readonly>
    </mat-form-field>
    <mat-form-field class="one-fifth-size">
        <input matInput placeholder="{{'DETAIL_AUDIT.CHANGED_DATE' | translate}}" [value]="model.changedDate | date: formats.DATE_TIME_FORMAT" readonly>
    </mat-form-field>
    <mat-form-field class="one-fifth-size">
        <input matInput placeholder="{{'DETAIL_AUDIT.AUTHORISED_BY' | translate}}" [value]="model.authorisedByName" readonly>
    </mat-form-field>
    <mat-form-field class="one-sixth-size">
        <input matInput placeholder="{{'DETAIL_AUDIT.AUTHORISED_DATE' | translate}}" [value]="model.authorisedDate | date: formats.DATE_TIME_FORMAT" readonly>
    </mat-form-field>
</div>
